/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-radio-button-field {
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  position: relative;
}
.ux-radio-button-field__media-container {
  overflow: hidden;
  position: relative;
}
.ux-radio-button-field--with-media {
  box-shadow: 0 5px 25px rgba(19, 19, 19, 0.1);
  display: flex;
  flex-direction: column;
}
.ux-radio-button-field--with-media img {
  display: block;
  min-width: 100%;
  transition: all 500ms ease-in-out;
}
.ux-radio-button-field--with-media:hover .ux-radio-button-field__media-container img {
  transform: scale(1.03);
}
.ux-radio-button-field--with-media .ux-radio-button-field__label-container, .ux-radio-button-field--as-box .ux-radio-button-field__label-container {
  align-items: center;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  min-height: 60px;
  padding: 30px;
}
.ux-radio-button-field--as-box {
  box-shadow: 0 7px 22px rgba(19, 19, 19, 0.1);
  width: 100%;
}
.ux-radio-button-field__description-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #fff;
  border: 0;
  color: #131313;
  cursor: pointer;
  display: block;
  padding: 0 10px;
  text-align: center;
  text-decoration: none;
  transform: translate(10px, 0);
}
.ux-radio-button-field__border {
  border: 2px solid #bbd03a;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}